import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { watch } from 'vue';
import LifeBridge from '@tnlife/tn-bridge';
import PageLayout from '@/layouts/page-layout.vue';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: PageLayout,
    meta: { auth: true }, // Все дочерние маршруты требуют авторизации
    children: [
      {
        path: '',
        name: 'forms',
        component: () => import('@/views/forms/forms-list.vue'),
      },
      {
        path: 'forms/:id/edit',
        name: 'form-builder',
        component: () => import('@/views/forms/form-builder.vue'),
      },
      {
        path: 'forms/:id/results',
        name: 'form-results',
        component: () => import('@/views/results/results-view.vue'),
      },
    ],
  },
  {
    // Футер корпоративного email-шаблона ведёт на <Host>/settings («изменить
    // настройки оповещения»); своего профиля настроек у нас нет — ведём на
    // список форм, оповещения включаются в настройках конкретной формы.
    path: '/settings',
    redirect: { name: 'forms' },
  },
  {
    // Страница логина (redirect на OIDC)
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
  },
  {
    // Публичное заполнение формы — без topbar (meta: { widget: true })
    path: '/f/:id',
    name: 'fill',
    meta: { widget: true },
    component: () => import('@/views/fill/fill-view.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/not-found.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Route guard: проверка авторизации для защищённых маршрутов
router.beforeEach(async (to) => {
  const authStore = useAuthStore();

  // Ждём завершения bootstrapAuth
  if (authStore.loading) {
    await new Promise<void>((resolve) => {
      const unwatch = watch(
        () => authStore.loading,
        (val) => {
          if (!val) {
            unwatch();
            resolve();
          }
        }
      );
    });
  }

  // Проверяем, требует ли маршрут авторизации
  const requiresAuth = to.matched.some((record) => record.meta.auth);

  if (requiresAuth && !authStore.isAuthenticated) {
    if (LifeBridge.isIFrame || LifeBridge.isWebView) {
      return true;
    }

    // Redirect на login с сохранением return URL
    // to.fullPath передаётся raw — Vue Router сам закодирует query-параметр
    return { name: 'login', query: { return: to.fullPath } };
  }

  // Если пользователь авторизован и пытается перейти на /login, перенаправляем на главную
  if (to.name === 'login' && authStore.isAuthenticated) {
    return { name: 'forms' };
  }

  return true;
});

export default router;
